import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxSpinnerModule } from 'ngx-spinner';
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { EditQueryComponent } from './components/edit-query/edit-query.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { ComponentNavigationComponent } from "./components/component-navigation/component-navigation.component";
import { RouterModule } from "@angular/router";
import { ActionLogsComponent } from "./components/actionlogs-component/action-logs.component";
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ResizableModule } from "../../core/directive/resizable/resizable.module";
import { DynamicPaginationDirective } from "src/app/core/directive/dynamicPagination/dynamic-pagination.directive";
import { MatCheckboxModule } from "@angular/material/checkbox";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    RouterModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    NgbModule,
    NgSelectModule,
    MatDialogModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    ResizableModule,
    MatCheckboxModule, 
    NgbTooltipModule,
    DynamicPaginationDirective
  ],
  declarations: [ConfirmDialogComponent, EditQueryComponent, ComponentNavigationComponent, ActionLogsComponent],
  exports: [ConfirmDialogComponent, ComponentNavigationComponent, ActionLogsComponent]
})
export class SharedModule{}
